import Axios from 'axios';

async function post(url: string, token: string, values?: any) {
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await Axios.post(
      url,
      JSON.stringify(JSON.stringify(values)),
      {
        headers,
      },
    );
    return response;
  } catch (e) {
    console.error(e); //Que hacemos con el error?
  }
}

export default post;
